module.exports = __webpack_public_path__ + "img/2.02.fa135bc7.jpg";